import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordService from '../Services/ForgotPasswordService';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await ForgotPasswordService.requestPasswordReset(email, window.location.origin);
      if (data.success) {
        setSubmitted(true);
      } else {
        setError(data.message || 'Something went wrong.');
      }
    } catch (err) {
      setError('Something went wrong.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#B3DFFF', marginTop: "-30px" }}>
      <div className="bg-white p-4 p-md-5 rounded-3 shadow-lg" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '64px', height: '64px' }}>
            <i className="fas fa-unlock-alt fa-2x text-primary"></i>
          </div>
          <h2 className="fw-bold">Forgot Password</h2>
          <p className="text-muted">Enter your email to receive a password reset link.</p>
        </div>
        {submitted ? (
          <div className="alert alert-success text-center">
            If the email exists in our system, a password reset link has been sent.
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label className="form-label">Email Address</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-envelope"></i>
                </span>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  disabled={loading}
                />
              </div>
            </div>
            {error && <div className="alert alert-danger text-center">{error}</div>}
            <button type="submit" className="btn btn-dark w-100 py-2" disabled={loading || !email}>
              {loading ? <span><i className="fas fa-spinner fa-spin me-2"></i>Sending...</span> : 'Send Reset Link'}
            </button>
            <div className="text-center mt-3">
              <button type="button" className="btn btn-link text-decoration-none" onClick={() => navigate('/signin')}>Back to Sign In</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword; 